import { format } from "date-fns";
import { useEffect, useState } from "react";

import styles from "../styles/components/Notification.module.scss";

import success from "../assets/icons/success.svg";
import warning from "../assets/icons/warning.svg";
import error from "../assets/icons/error.svg";
import close from "../assets/icons/close_black.svg";
import { useAppDispatch } from "../hooks/redux";
import { setNotification } from "../redux/actions";

type Props = {
    object: NotificationObject
}

type State = {
    type: "in" | "out" | "hidden"
}

let timeoutIds:any = []

const Notification : React.FunctionComponent<Props> = ({object}) => {
    const dispatch = useAppDispatch();
    const [state, setstate] = useState<State>();
    
    const clearAllTimeouts = () => {
        timeoutIds.forEach(clearTimeout);
        timeoutIds = [];
    }

    useEffect(()=>{
        if(object?.type){
            clearAllTimeouts()

            let duration = object.duration || 5000

            setstate({type:"in"})
            timeoutIds[timeoutIds.length] = setTimeout(function(){
                if(object.type !== "pending"){
                    setstate({type:"out"})
                    timeoutIds[timeoutIds.length] = setTimeout(function(){
                        dispatch(setNotification(null))
                    }, 600)
                }
            }, duration)
        }
    }, [object])

    return (
        <div className={`${state?.type === "in" && styles.notification_in} ${state?.type === "out" && styles.notification_out} ${styles.notification}`}>
            <div className={`${styles.border} ${object?.type === "success" && styles.success} ${object?.type === "error" && styles.error} ${object?.type === "pending" && styles.pending} ${object?.type === "warning" && styles.warning}`}></div>
            <div className={styles.status}>
                {object?.type === "success" && <img className={styles.symbol} src={success} alt="status"/>}
                {object?.type === "error" && <img className={styles.symbol} src={error} alt="status"/>}
                {object?.type === "warning" && <img className={styles.symbol} src={warning} alt="status"/>}
                {object?.type === "pending" && <div className={styles.symbol_loader}></div>}
            </div>
            <div className={styles.content}>
                <p className={styles.title}>{object?.title}</p>
                <p className={styles.description}>{object?.message}</p>
                <p className={styles.hour}>{format(new Date, "HH:mm")}</p>
            </div>
            <div className={styles.close}>
                <button onClick={()=>{setstate({type:"out"})}} className={styles.button}><img className={styles.icon} src={close} alt="close"/></button>
            </div>
        </div>
    )
}

export default Notification